import React from "react"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"
import { Link } from "react-router-dom"
import ActivityFeedEventSearchResult from "../../../state/search/Dto"
import { Intl } from "../../../state/helpers/IntlProps"

type Props = {
    intl: Intl,
    activity: ActivityFeedEventSearchResult,
}

const messages = defineMessages({
    "default": {
        id: "dashboard.activity_feed_event_invoice_sync_request.sync_received_default",
        defaultMessage: "There was an update in invoice {identifier} for customer {customer}",
    },
    "payment-removed": {
        id: "dashboard.activity_feed_event_invoice_sync_request.sync-received-removed",
        defaultMessage: "Payment Removed in invoice {identifier} for customer {customer}",
    },
})


const ActivityFeedEventInvoiceSyncRequest = (props: Props) => {

    const parsedData = JSON.parse(props.activity.getObjectDataJson())
    const content = parsedData.content
    const errorType = parsedData.syncUpdated
    const messageValues = {
        identifier: <Link to={"/" + props.activity.getObjectType() + "/" + props.activity.getObjectId() + "/edit"}>
            {props.activity.getIdentifier()}
        </Link>,
        customer: <Link to={"/contacts/" + props.activity.getContactId() + "/details"}>
            {props.activity.getContactName()}
        </Link>,
    }

    let message = <FormattedMessage
        {...messages["default"]}
        values={messageValues}
    />

    if (errorType && messages[errorType]) {
        message = <FormattedMessage
            {...messages[errorType]}
            values={messageValues}
        />
    }


    return (
        <div>
            {message}
            <div className={"row pl-3"}>
                <div className={"w-100 mt-1"}>
                    <blockquote className="blockquote mb-0 bg-light py-3">
                        <p className="mb-0">{content}</p>
                    </blockquote>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(ActivityFeedEventInvoiceSyncRequest)


// WEBPACK FOOTER //
// ./src/dashboard/activity-feed/components/ActivityFeedEventInvoiceSyncRequest.tsx